import React, { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { HiCasLogoSvg } from '~/Components/SVG'
import { LoginHero } from './LoginHero'
import styles from './Login.module.less'

interface AuthLayoutProps {
  children: React.ReactNode
}

// Shared two-panel shell for every unauthenticated route (/login, /register, /forgotpassword):
// brand + page content on the left, hero carousel on the right — see Login.module.less.
export const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  const { t } = useTranslation()

  // index.html has no <meta viewport> tag, so on phones the browser falls back to a ~980px
  // desktop-style layout. We only want a real mobile viewport on these auth routes, so we set
  // it here instead of changing it app-wide, and put back whatever was there when we leave.
  useEffect(() => {
    const existing = document.querySelector('meta[name="viewport"]')
    const previousContent = existing ? existing.getAttribute('content') : null
    const meta = existing || document.createElement('meta')
    meta.setAttribute('name', 'viewport')
    meta.setAttribute('content', 'width=device-width, initial-scale=1')
    if (!existing) {
      document.head.appendChild(meta)
    }

    return () => {
      if (previousContent === null) {
        meta.remove()
      } else {
        meta.setAttribute('content', previousContent)
      }
    }
  }, [])

  return (
    <div className={styles.page}>
      <section className={styles.panel}>
        <div className={styles.panelSpacer} />
        <div className={styles.panelInner}>
          <div className={styles.logo}>
            <HiCasLogoSvg width={130} height={50} />
          </div>
          {children}
          <div className={styles.footer}>
            © {new Date().getFullYear()} HICAS. {t('loginPage.footer')}
          </div>
        </div>
        <div className={styles.panelSpacer} />
      </section>
      <aside className={styles.hero}>
        <LoginHero />
      </aside>
    </div>
  )
}
